var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointsToday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.464,
    height: 46.469,
    viewBox: "0 0 55.464 46.469",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6459",
    "data-name": "Group 6459",
    transform: "translate(-128 -493)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6458",
    "data-name": "Group 6458"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15662",
    "data-name": "Path 15662",
    d: "M-621.639,70.333c-2.71-3.466-3.516-6.384-2.328-8.438l1.368-2.37q1.195-2.07,2.392-4.141c1.271-2.2,4.658-2.921,9.537-2.027a51,51,0,0,1,15.509,6.135,61.331,61.331,0,0,1,7.152,4.8l-.966,1.232a59.773,59.773,0,0,0-6.968-4.681A49.425,49.425,0,0,0-610.953,54.9c-4.117-.755-7-.292-7.9,1.27-1.726,2.992,3.835,10.587,14.865,17.125l-.8,1.347a49.814,49.814,0,0,1-12.584-10.186,15.021,15.021,0,0,1-3.133-5.428l-.741,1.283-1.369,2.371c-.677,1.171-.241,3.043,1.187,5.263l1.185-2.054,1.357.782-1.542,2.674.019.025a32.678,32.678,0,0,0,3.957,4.145l1.342-2.326,1.357.782-1.491,2.585a56.2,56.2,0,0,0,5.576,4.065l-.846,1.318a45.947,45.947,0,0,1-11.128-9.6Z",
    transform: "translate(752.5 440.019)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15663",
    "data-name": "Path 15663",
    d: "M-545.329,87.477a57.56,57.56,0,0,1,11.656,5.28c1.736,1,3.4,2.052,4.94,3.118l.89-1.289c-1.576-1.089-3.274-2.16-5.047-3.185a59.133,59.133,0,0,0-11.993-5.425c-3.891-1.158-6.272-1.039-7.077.353s.282,3.513,3.232,6.3a59.215,59.215,0,0,0,10.7,7.676c.278.16.559.319.836.476l.769-1.364c-.274-.154-.551-.312-.823-.468a57.634,57.634,0,0,1-10.4-7.457c-2.805-2.654-3.158-4.027-2.953-4.383s1.573-.738,5.274.364Z",
    transform: "translate(688.316 411.421)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15666",
    "data-name": "Path 15666",
    d: "M-598.628,297.926h-1.566v1.985h-1.985v1.566h1.985v1.985h1.566v-1.985h1.984v-1.566h-1.984Z",
    transform: "translate(732.68 222.522)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15667",
    "data-name": "Path 15667",
    d: "M-288.121,92.273h1.566V90.289h1.981V88.723h-1.981V86.738h-1.566v1.985h-1.985v1.566h1.985v1.985Z",
    transform: "translate(455.577 410.045)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6456",
    "data-name": "Group 6456",
    transform: "translate(144.838 457.521) rotate(57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6453",
    "data-name": "Group 6453",
    transform: "translate(54.082 4.813)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6452",
    "data-name": "Group 6452",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_310",
    "data-name": "Ellipse 310",
    cx: 5.339,
    cy: 15.816,
    rx: 5.339,
    ry: 15.816,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6455",
    "data-name": "Group 6455",
    transform: "translate(51.208)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6454",
    "data-name": "Group 6454",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15668",
    "data-name": "Path 15668",
    d: "M70.919,20.629c0-1.172-.041-2.319-.116-3.438h.009l-.064-.782c0-.05-.011-.1-.015-.148q-.063-.731-.147-1.442c-.021-.186-.044-.37-.068-.554q-.072-.557-.157-1.1c-.047-.307-.1-.609-.151-.91-.045-.254-.092-.507-.14-.755-.083-.419-.172-.829-.266-1.236-.031-.133-.061-.266-.093-.4-.041-.171-.077-.348-.121-.516l-.108-.414h-.014A26.6,26.6,0,0,0,68.282,5.5h.064l-.577-1.133A10.082,10.082,0,0,0,65.163.943c-.024-.019-.048-.036-.073-.054a5.009,5.009,0,0,0-.577-.38c-.09-.051-.181-.1-.273-.143s-.166-.08-.249-.112a3.624,3.624,0,0,0-.525-.162c-.052-.012-.1-.021-.157-.03a3.337,3.337,0,0,0-.6-.061H59.421c-4.529,0-8.213,9.254-8.213,20.629s3.684,20.629,8.213,20.629h3.285a3.341,3.341,0,0,0,.6-.061c.053-.01.1-.019.157-.03A3.772,3.772,0,0,0,63.991,41c.083-.032.166-.073.248-.112s.183-.092.274-.143a4.922,4.922,0,0,0,.575-.379c.025-.019.05-.036.075-.056a10.084,10.084,0,0,0,2.606-3.424l.577-1.133h-.063a26.59,26.59,0,0,0,1.186-3.438h.014l.107-.414c.044-.168.079-.345.12-.516.033-.133.063-.27.094-.405.093-.4.182-.81.264-1.226.05-.252.1-.509.143-.767.052-.3.1-.6.149-.9q.084-.545.157-1.1.035-.274.067-.551.083-.711.147-1.441c0-.05.011-.1.015-.148l.064-.782H70.8C70.878,22.948,70.919,21.8,70.919,20.629Zm-1.228-6.288.01.077q.091.689.162,1.4H67.409c-.007-.068-.016-.134-.022-.2-.028-.283-.06-.562-.092-.84-.039-.329-.081-.655-.126-.979-.017-.12-.034-.241-.051-.361-.159-1.076-.349-2.121-.579-3.12h2.4A37.855,37.855,0,0,1,69.691,14.341Zm-1.117-5.4H66.183l0-.007c-.023-.083-.046-.164-.07-.247q-.139-.491-.289-.961c-.016-.049-.03-.1-.046-.148-.113-.345-.23-.679-.352-1.005-.029-.077-.058-.153-.087-.228Q65.172,5.91,65,5.5h2.273A22.27,22.27,0,0,1,68.574,8.939ZM62.706,1.375a2.864,2.864,0,0,1,.453.04c.045.007.09.018.135.027a3,3,0,0,1,.33.087c.044.014.088.027.132.044a3.868,3.868,0,0,1,.885.476l.092.068c.133.1.265.206.4.326l.034.03A8.332,8.332,0,0,1,66.5,4.126H64.357A10.932,10.932,0,0,0,62.39,1.375h.316ZM59.42,37.82c-3.339,0-6.16-7.872-6.16-17.191S56.081,3.438,59.42,3.438s6.16,7.872,6.16,17.191S62.76,37.82,59.42,37.82Zm5.741.966-.032.028c-.131.12-.264.228-.4.327-.03.022-.06.045-.09.067a3.844,3.844,0,0,1-.885.477c-.044.017-.087.03-.132.044a3.03,3.03,0,0,1-.33.087c-.045.009-.09.019-.135.027a2.869,2.869,0,0,1-.453.04H62.39a10.941,10.941,0,0,0,1.967-2.751H66.5A8.34,8.34,0,0,1,65.162,38.786Zm2.109-3.029H65q.176-.408.34-.842c.029-.076.058-.151.087-.228.121-.326.239-.66.352-1.005.016-.049.031-.1.046-.148q.15-.469.289-.961c.023-.083.047-.164.07-.247l0-.007h2.391A22.221,22.221,0,0,1,67.27,35.757Zm2.43-8.918-.01.077a37.868,37.868,0,0,1-.751,4.027h-2.4c.23-1,.42-2.046.579-3.123.017-.117.034-.236.05-.353.046-.328.089-.657.128-.992.032-.275.063-.552.092-.831.007-.068.016-.134.022-.2h2.453Q69.792,26.15,69.7,26.839Zm.277-2.772h-2.46c0-.036.005-.072.008-.108s.007-.094.01-.141c.029-.462.05-.93.066-1.4q.006-.169.01-.338c.013-.479.023-.962.023-1.45s-.009-.97-.023-1.45q0-.169-.01-.338c-.016-.471-.037-.939-.066-1.4,0-.047-.007-.094-.01-.141s-.005-.072-.008-.108h2.46c.078,1.117.12,2.264.12,3.438S70.055,22.951,69.977,24.067Z",
    transform: "translate(-51.208)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointsToday);
export default __webpack_public_path__ + "static/media/points_today.21cb9e9b5ecf2dce0ccf90d22ab701be.svg";
export { ForwardRef as ReactComponent };